const colors = Object.freeze({
  black: "#000000",
  white: "#FFFFFF",
  gold: "#D7B377",
  offWhite: "#F6F6F6",
  lightGrey: "#808080",
  darkGrey: "#CED0CE",
  opal: "#9FB8AD",
  red: "#FF6961",
});

export default colors;
